<template>
  <v-container fill-height style="min-height: calc(100vh - 70px - 84px);">
    <notifications class="pa-3"/>
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="10">
        <div>
          <h2 class="text-md-h5">
            Ambil Nomor Antrian
          </h2>
          <p class="mb-1">
            Pilih tujuan kunjungan
          </p>
        </div>
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col cols="12" md="4" class="align-self-center">
            <v-card
              color="blue darken-4"
              dark
              flat
              @click="ambilAntrian(0)">
              <v-card-title class="subtitle-2">
                Direktur
              </v-card-title>
              <v-card-subtitle>
                I Nyoman Abdi, SE., M.eCom
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="align-self-center">
            <v-card
              color="blue darken-4"
              dark
              flat
              @click="ambilAntrian(1)">
              <v-card-title class="subtitle-2">
                W.D. Bidang Akademik
              </v-card-title>
              <v-card-subtitle>
                A.A.N. Bagus Mulawarman, S.T., M.T.
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="align-self-center">
            <v-card
              color="blue darken-4"
              dark
              flat
              @click="ambilAntrian(2)">
              <v-card-title class="subtitle-2">
                W.D. Bidang Keuangan dan Umum
              </v-card-title>
              <v-card-subtitle>
                I Ketut Parnata, SE, MMA.,Ak
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="align-self-center">
            <v-card
              color="blue darken-4"
              dark
              flat
              @click="ambilAntrian(3)">
              <v-card-title class="subtitle-2">
                W.D. Bidang Kemahasiswaan dan Alumni
              </v-card-title>
              <v-card-subtitle>
                I.G.N. Bagus Catur Bawa, ST, M. Kom.
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="align-self-center">
            <v-card
              color="blue darken-4"
              dark
              flat
              @click="ambilAntrian(4)">
              <v-card-title class="subtitle-2">
                Wakil Direktur Bidang Kerja Sama
              </v-card-title>
              <v-card-subtitle>
                Dr. I Ketut Sutama, MA.
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
        <div id="printAntrian" v-show="datares">
          <div style="text-align: center; height: fit-content;">
            <img class="mr-3" :src="'https://kiosk.ajkpnb.com/img/logo-pnb.3aae610b.png'" height="55" :alt="apptitle"/>
            <h4><b>Politeknik Negeri Bali</b></h4>
            <div>Nomor Antrian:</div>
            <h1>{{ datares.no }}</h1>
            <div>Terimakasih atas kunjunganya</div>
            <div>Semoga anda senang disini</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- modal loading -->
    <v-dialog
      v-model="dmodal.loading"
      persistent
      width="300">
      <v-card>
        <v-card-text class="pt-6">
          <div v-if="loading.tiket">
            Please stand by
            <v-progress-linear
              indeterminate>
            </v-progress-linear>
          </div>
          <div v-if="dmodal.image" class="text-center">
            <img :src="require('../../assets/suksma.png')" width="120"/>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import thankSound from '@/assets/thankyou.mp3';

export default {
  name: 'Antrian',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      contact: false,
      regnew: false,
      tiket: false,
    },
    formupdate: {
      valid: false,
    },
    api: process.env.VUE_APP_API,
    apptitle: process.env.VUE_APP_TITLE,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    publickey: '123',
    contact: {
      name: '',
      email: '',
      subject: '',
      message: '',
    },
    formin: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v.length >= 16 || v === 'majujaya') || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 12) || 'Max 12 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => (!!v && /.+@.+\..+/.test(v)) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    word: 'Vue',
    thankSound,
    listbertemu: ['Direktur', 'Wakil Direktur 1', 'Wakil Direktur 2', 'lainnya'],
    listtujuan: ['Institusi', 'Studi Banding', 'Tugas', 'lainnya'],
    listwisman: [
      {
        label: 'Domestik',
        value: 0,
      },
      {
        label: 'Mancanegara',
        value: 1,
      },
    ],
    adddata: {
      perihal: '',
      bertemu: '',
      pekerjaan: '',
      nama: '',
    },
    dmodal: {
      register: false,
      tiket: false,
      loading: false,
      image: false,
    },
    dmodaldata: {
      tiket: null,
    },
    regflag: false,
    datares: '',
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  watch: {
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  mounted() {
    // console.log('1');
  },
  methods: {
    redirectDetail(direction, delay) {
      const thisVue = this;
      setTimeout(() => (thisVue.$router.push(direction)), delay);
    },
    ambilAntrian(kode) {
      const notifdata = {
        title: 'Notifikasi Antrian',
        text: '',
        type: 'warm',
      };
      this.dmodal.loading = true;
      this.dmodal.image = false;
      this.loading.tiket = true;
      this.datares = '';
      this.axios
        .post(
          this.api + '/public/antrian',
          qs.stringify(
            {
              type: kode,
            },
          ),
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          // this.alertdata.show = true;
          this.dmodal.loading = false;
          this.loading.tiket = false;
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              // print tiket
              this.datares = {
                no: resdata.data,
                type: kode,
              };
              // show image
              this.dmodal.loading = true;
              this.dmodal.image = true;
              // play sound
              const note = new Audio(this.thankSound);
              setTimeout(() => {
                note.play();
              }, 500);
              setTimeout(() => {
                note.play();
                this.printTiket();
              }, 1000);
              // wait - 4 second - close
              setTimeout(() => {
                this.dmodal.loading = false;
                this.dmodal.image = false;
                this.redirectDetail({ name: 'Index' }, 1000);
              }, 4000);
              // notif
              notifdata.type = 'success';
              notifdata.text = 'Terimakasih!';
            } else {
              notifdata.type = 'error';
              notifdata.text = resdata.message;
            }
          } else {
            notifdata.type = 'error';
            notifdata.text = 'Internal services error!';
          }
          this.$notify(notifdata);
        })
        .catch((error) => {
          console.log(error);
          notifdata.type = 'error';
          notifdata.text = 'Internal services error!';
          this.$notify(notifdata);
          this.loading.tiket = false;
          this.dmodal.loading = false;
        });
    },
    submitAddData() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        const notifdata = {
          title: 'Notifikasi Bukutamu',
          text: '',
          type: 'warm',
        };
        this.dmodal.loading = true;
        this.dmodal.image = false;
        this.loading.tiket = true;
        this.datares = '';
        this.axios
          .post(
            this.api + '/public/bukutamu',
            qs.stringify(
              this.adddata,
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.publickey,
              },
            },
          )
          .then((res) => {
            // this.alertdata.show = true;
            this.dmodal.loading = false;
            this.loading.tiket = false;
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                // show image
                this.dmodal.loading = true;
                this.dmodal.image = true;
                // play sound
                const note = new Audio(this.thankSound);
                setTimeout(() => {
                  note.play();
                }, 500);
                // wait - 4 second - close
                setTimeout(() => {
                  this.dmodal.loading = false;
                  this.dmodal.image = false;
                  this.redirectDetail({ name: 'Index' }, 1000);
                }, 4000);
                // notif
                notifdata.type = 'success';
                notifdata.text = 'Terimakasih!';
                // this.alertdata.type = 'success';
                // this.alertdata.text = 'Thank you!';
                // this.datares = resdata.data;
              } else {
                notifdata.type = 'error';
                notifdata.text = resdata.message;
                // this.alertdata.type = 'error';
                // this.alertdata.text = resdata.message;
              }
            } else {
              notifdata.type = 'error';
              notifdata.text = 'Internal services error!';
              // this.alertdata.type = 'error';
              // this.alertdata.text = 'Internal services error!';
            }
            this.$notify(notifdata);
          })
          .catch((error) => {
            console.log(error);
            notifdata.type = 'error';
            notifdata.text = 'Internal services error!';
            this.$notify(notifdata);
            // this.alertdata.show = true;
            // this.alertdata.type = 'error';
            // this.alertdata.text = 'Internal services error!';
            this.loading.tiket = false;
            this.dmodal.loading = false;
          });
      }
    },
    printTiket() {
      // console.log('print');
      // console.log(this.datares);
      // opsi 1
      // this.$htmlToPaper('printAntrian');
      // opsi 2
      const prtHtml = document.getElementById('printAntrian').innerHTML;
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
